import { render, staticRenderFns } from "./newShiftDialog.vue?vue&type=template&id=5146424e&"
import script from "./newShiftDialog.vue?vue&type=script&lang=js&"
export * from "./newShiftDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5146424e')) {
      api.createRecord('5146424e', component.options)
    } else {
      api.reload('5146424e', component.options)
    }
    module.hot.accept("./newShiftDialog.vue?vue&type=template&id=5146424e&", function () {
      api.rerender('5146424e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Roster/RosterForm/components/newShiftDialog.vue"
export default component.exports